import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// 🚀 OPTIMIZACIÓN: Importar optimizadores de rendimiento
import './app/shared/utils/performance-optimizer';

// Marcar Safari en body para estilos condicionales
try {
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafari) {
    document.documentElement.classList.add('is-safari');
    document.body.classList.add('is-safari');
  }
  
  // 🔇 Reducir ruido de logs en Safari (se habilitan sólo con ?debug=1 o localStorage.DEBUG='1')
  const url = new URL(window.location.href);
  const debugParam = url.searchParams.get('debug');
  const memParam = url.searchParams.get('mem');
  const safeParam = url.searchParams.get('safe');
  if (debugParam === '1') {
    try { localStorage.setItem('DEBUG', '1'); } catch {}
  } else if (debugParam === '0') {
    try { localStorage.setItem('DEBUG', '0'); } catch {}
  }
  if (memParam === '1') {
    try { localStorage.setItem('HOME_PROBE', '1'); } catch {}
  }
  if (safeParam === '1') {
    try { localStorage.setItem('PERF_GUARD_PAUSE', '1'); } catch {}
  } else if (safeParam === '0') {
    try { localStorage.setItem('PERF_GUARD_PAUSE', '0'); } catch {}
  }
  const debugEnabled = ((): boolean => {
    try { return localStorage.getItem('DEBUG') === '1'; } catch { return false; }
  })();
  (window as any).__SAFE_MODE = ((): boolean => {
    try { return localStorage.getItem('PERF_GUARD_PAUSE') === '1'; } catch { return false; }
  })();

  // 🔇 Silenciar logs globalmente si NO está activo DEBUG (aplica a todos los navegadores)
  if (!debugEnabled) {
    const noop = (..._args: any[]) => {};
    const c = console as any;
    // Guardar originales para poder restaurar cuando se active DEBUG
    (window as any).__consoleOriginals = (window as any).__consoleOriginals || {
      log: c.log,
      info: c.info,
      debug: c.debug,
      time: c.time,
      timeEnd: c.timeEnd,
      group: c.group,
      groupCollapsed: c.groupCollapsed,
      table: c.table,
      trace: c.trace,
    };
    // Conservar warnings y errores; silenciar resto
    c.info = noop;
    c.debug = noop;
    c.log = noop;
    c.time = noop;
    c.timeEnd = noop;
    c.group = noop;
    c.groupCollapsed = noop;
    c.table = noop;
    c.trace = noop;
  } else {
    // Restaurar consola si DEBUG=1
    try {
      const o = (window as any).__consoleOriginals;
      if (o) {
        Object.assign(console, o);
      }
    } catch {}
  }
  // Si debug está activo, observar Long Tasks y recursos para diagnóstico
  if (debugEnabled) {
    try {
      const w = window as any;
      w.__longTasks = { count: 0, total: 0, max: 0 };
      if ('PerformanceObserver' in window) {
        const po = new PerformanceObserver((list) => {
          for (const entry of list.getEntries()) {
            const dur = (entry as any).duration || 0;
            w.__longTasks.count += 1;
            w.__longTasks.total += dur;
            if (dur > w.__longTasks.max) w.__longTasks.max = dur;
          }
        });
        po.observe({ type: 'longtask', buffered: true } as any);
      }
    } catch {}
  }
} catch {}

if (environment.production) {
  enableProdMode();
}

const bootT0 = (performance.now?.() ?? Date.now());
try { performance.mark('boot:start'); } catch {}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(ref => {
    // Ensure Angular destroys itself on hot reloads.
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;

    // 📈 Medir latencia de arranque del frontend
    const t1 = (performance.now?.() ?? Date.now());
    try {
      performance.mark('boot:end');
      performance.measure('boot:angular-bootstrap', 'boot:start', 'boot:end');
    } catch {}
    try {
      (window as any).__bootPerf = { t0: bootT0, t1, dur: Number((t1 - bootT0).toFixed(1)) };
      const debug = localStorage.getItem('DEBUG') === '1';
      if (debug) {
        // Panel de rendimiento deshabilitado para reducir ruido visual.
        // Si deseas reactivarlo temporalmente, elimina estos comentarios.
        /*
        try {
          const panel = document.createElement('div');
          panel.id = 'perf-panel';
          panel.style.cssText = 'position:fixed;z-index:99999;right:8px;bottom:8px;background:rgba(0,0,0,.8);color:#fff;padding:8px 10px;border-radius:6px;font:12px/1.4 -apple-system,Segoe UI,Roboto,Helvetica,Arial;max-width:70vw;backdrop-filter:saturate(180%) blur(8px)';
          const fmt = (n: number) => (n >= 1000 ? (n/1000).toFixed(2)+'s' : n.toFixed(0)+'ms');
          const boot = (window as any).__bootPerf;
          const http = (window as any).__httpPerf || [];
          const lt = (window as any).__longTasks || { count: 0, total: 0, max: 0 };
          const last = http.slice(-3).map((h: any) => `${h.status} ${fmt(h.dur)} ${h.method} ${String(h.url).split('?')[0].slice(-40)}`).join('\n');
          panel.textContent = `Boot: ${fmt(boot?.dur || 0)}\nLongTasks: ${lt.count} tot=${fmt(lt.total)} max=${fmt(lt.max)}\nHTTP: ${http.length} req\n${last}`;
          panel.title = 'Click para cerrar';
          panel.onclick = () => panel.remove();
          document.body.appendChild(panel);
          const id = setInterval(() => {
            const http2 = (window as any).__httpPerf || [];
            const lt2 = (window as any).__longTasks || { count: 0, total: 0, max: 0 };
            const last2 = http2.slice(-3).map((h: any) => `${h.status} ${fmt(h.dur)} ${h.method} ${String(h.url).split('?')[0].slice(-40)}`).join('\n');
            panel.textContent = `Boot: ${fmt(boot?.dur || 0)}\nLongTasks: ${lt2.count} tot=${fmt(lt2.total)} max=${fmt(lt2.max)}\nHTTP: ${http2.length} req\n${last2}`;
          }, 2000);
          panel.addEventListener('remove', () => clearInterval(id));
        } catch {}
        */
      }
    } catch {}

    // Otherwise, log the boot error
  })
  .catch(err => console.error(err));
